import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExpenseVouchersService {

  private _baseUrl: string = "";
  private _controllerName: string = "";

  constructor(private _http: HttpClient) {
    this._baseUrl = environment.apiUrl;
    this._controllerName = "ExpenseVoucher"
  }

  // private getHeaders(): HttpHeaders{
  //   return new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${this.getToken()}`
  //   })
  // }

  insert(payload: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/${this._controllerName}`, payload).pipe(catchError(this.handleErrors))
  }

  update(id: number, payload: any): Observable<any> {
    return this._http.put<any>(`${this._baseUrl}/${this._controllerName}/${id}`, payload).pipe(catchError(this.handleErrors))
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  getAll(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/`).pipe(catchError(this.handleErrors))
  }

  getById(id: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/${id}`).pipe(catchError(this.handleErrors))
  }

  // Métodos de anulación
  cancelExpenseVoucher(id: number, cancellationReason: string): Observable<any> {
    const payload = { cancellationReason };
    return this._http.put<any>(`${this._baseUrl}/${this._controllerName}/${id}/cancel`, payload)
      .pipe(catchError(this.handleErrors));
  }

  getCancelledExpenseVouchers(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/cancelled`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene TODOS los comprobantes de egreso (activos + anulados)
   * @returns Observable con la lista completa de comprobantes
   */
  getAllIncludingCancelled(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/all-including-cancelled`)
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene comprobantes de egreso con filtros de fecha
   * @param startDate Fecha de inicio (opcional)
   * @param endDate Fecha de fin (opcional)
   * @param dateType Tipo de fecha: "Creation" o "Payment" (por defecto "Creation")
   * @param includeCancelled Incluir comprobantes anulados (por defecto false)
   * @returns Observable con la lista filtrada de comprobantes
   */
  getExpenseVouchersWithDateFilter(startDate?: Date, endDate?: Date, dateType: string = 'Creation', includeCancelled: boolean = false): Observable<any> {
    let params = new URLSearchParams();
    
    if (startDate) {
      params.append('startDate', startDate.toISOString());
    }
    if (endDate) {
      params.append('endDate', endDate.toISOString());
    }
    if (dateType) {
      params.append('dateType', dateType);
    }
    params.append('includeCancelled', includeCancelled.toString());

    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/filtered?${params.toString()}`)
      .pipe(catchError(this.handleErrors));
  }


  /**
   * Descarga el PDF del comprobante de egreso
   * @param id ID del comprobante
   * @returns Observable con el archivo Blob
   */
  downloadPdf(id: number): Observable<Blob> {
    return this._http.get(`${this._baseUrl}/${this._controllerName}/${id}/pdf`, { responseType: 'blob' })
      .pipe(catchError(this.handleErrors));
  }

  /**
   * 🆕 Obtiene comprobantes de egreso con paginación, búsqueda y filtros del lado servidor
   */
  getExpenseVouchersPaged(parameters: any): Observable<any> {
    let params = new HttpParams();
    
    // Paginación
    if (parameters.pageNumber !== undefined && parameters.pageNumber !== null) {
      params = params.append('pageNumber', parameters.pageNumber.toString());
    }
    if (parameters.pageSize !== undefined && parameters.pageSize !== null) {
      params = params.append('pageSize', parameters.pageSize.toString());
    }
    
    // Búsqueda
    if (parameters.searchTerm) {
      params = params.append('searchTerm', parameters.searchTerm);
    }
    
    // Ordenamiento
    if (parameters.sortBy) {
      params = params.append('sortBy', parameters.sortBy);
    }
    if (parameters.sortOrder) {
      params = params.append('sortOrder', parameters.sortOrder);
    }
    
    // Filtros de fecha
    if (parameters.startDate) {
      params = params.append('startDate', parameters.startDate.toISOString());
    }
    if (parameters.endDate) {
      params = params.append('endDate', parameters.endDate.toISOString());
    }
    if (parameters.dateType) {
      params = params.append('dateType', parameters.dateType);
    }
    
    // Filtros de estado
    if (parameters.cancellationFilter) {
      params = params.append('cancellationFilter', parameters.cancellationFilter);
    }
    
    // Filtro por ID
    if (parameters.filterId !== undefined && parameters.filterId !== null) {
      params = params.append('filterId', parameters.filterId.toString());
    }

    // Filtros específicos
    if (parameters.bankId !== undefined && parameters.bankId !== null) {
      params = params.append('bankId', parameters.bankId.toString());
    }

    return this._http.get<any>(`${this._baseUrl}/${this._controllerName}/paged`, { params })
      .pipe(catchError(this.handleErrors));
  }

  private handleErrors(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.log("Ocurrio un error", error.error.message);
    } else {
      console.log(`Ocurrio un error ${error.status}, ${error.error}`);
    }
    return throwError(() => new Error('Algo salió mal; por favor, intente nuevamente más tarde.'));
  }
}
